import script from "./privacy_cmp.vue?vue&type=script&setup=true&lang=js"
export * from "./privacy_cmp.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__